import debounce from "lodash/debounce";
import throttle from "lodash/throttle";

class Header {
  constructor(header) {
    this.header = header;
    this.mobileMenuButton = header.querySelector(
      ".site-header__mobile-menu-button",
    );
    this.mobileMenu = header.querySelector(".site-header__mobile-menu");
    this.mobileMenuOverlay = header.querySelector(
      ".site-header__mobile-menu-overlay",
    );
    this.mobileNavLinks = header.querySelectorAll(
      ".site-header__mobile-menu-nav-list-item-link",
    );
    this.mobileSubNavs = header.querySelectorAll(
      ".site-header__mobile-menu-subnav",
    );

    this.desktopBreakpoint = this.getDesktopBreakpoint();

    this.setHeaderHeight();
    this.setScrolled();
    this.events();
  }

  events() {
    window.addEventListener(
      "resize",
      debounce(() => {
        this.setHeaderHeight();

        if (window.innerWidth >= this.desktopBreakpoint) {
          this.closeMobileMenu();
        }
      }, 250),
    );

    window.addEventListener(
      "scroll",
      throttle(() => {
        this.setScrolled();
      }, 100),
    );

    this.mobileMenuButton?.addEventListener("click", () =>
      this.toggleMobileMenu(),
    );

    this.mobileMenuOverlay?.addEventListener("click", () =>
      this.closeMobileMenu(),
    );

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        this.closeMobileMenu();
      }
    });

    this.mobileNavLinks.forEach((link) => {
      link.addEventListener("click", (e) => this.openMobileSubNav(e, link));
    });

    this.mobileSubNavs.forEach((subnav) => {
      const back = subnav.querySelector(
        ".site-header__mobile-menu-subnav-back",
      );
      back?.addEventListener("click", () => this.closeMobileSubnav(subnav));
    });
  }

  setScrolled() {
    const hasScrolled = window.scrollY > 12;
    this.header.classList.toggle("site-header--scrolled", hasScrolled);
  }

  setHeaderHeight() {
    document
      .querySelector("body")
      .style.setProperty("--header-height", `${this.header.offsetHeight}px`);
  }

  getDesktopBreakpoint() {
    const rootStyles = getComputedStyle(document.documentElement);
    const bootstrapXl = rootStyles.getPropertyValue("--bs-breakpoint-xl");
    const parsed = Number.parseInt(bootstrapXl, 10);

    return Number.isNaN(parsed) ? 1200 : parsed;
  }

  toggleMobileMenu() {
    if (!this.mobileMenu) {
      return;
    }

    const isActive = this.mobileMenu.classList.contains(
      "site-header__mobile-menu--active",
    );

    if (isActive) {
      this.closeMobileMenu();
      return;
    }

    this.mobileMenuButton?.classList.add(
      "site-header__mobile-menu-button--active",
    );
    this.mobileMenu.classList.add("site-header__mobile-menu--active");
    this.mobileMenuOverlay?.classList.add(
      "site-header__mobile-menu-overlay--active",
    );
    this.mobileMenuButton?.setAttribute("aria-expanded", "true");
    this.mobileMenu?.setAttribute("aria-hidden", "false");
  }

  closeMobileMenu() {
    this.mobileMenuButton?.classList.remove(
      "site-header__mobile-menu-button--active",
    );
    this.mobileMenu?.classList.remove("site-header__mobile-menu--active");
    this.mobileMenuOverlay?.classList.remove(
      "site-header__mobile-menu-overlay--active",
    );
    this.mobileMenuButton?.setAttribute("aria-expanded", "false");
    this.mobileMenu?.setAttribute("aria-hidden", "true");

    this.mobileSubNavs.forEach((subnav) => {
      subnav.classList.remove("site-header__mobile-menu-subnav--active");
    });
  }

  openMobileSubNav(e, link) {
    if (link.dataset.children !== "0") {
      e.preventDefault();

      this.mobileSubNavs.forEach((subnav) => {
        subnav.classList.toggle(
          "site-header__mobile-menu-subnav--active",
          subnav.dataset.parent === link.dataset.id,
        );
      });
      return;
    }

    this.closeMobileMenu();
  }

  closeMobileSubnav(subnav) {
    subnav.classList.remove("site-header__mobile-menu-subnav--active");
  }
}

export default Header;
